import { useState, useRef, useEffect } from 'react'
import { useChat } from '../contexts/ChatContext'

export default function MessageInput() {
  const { sendMessage, isStreaming } = useChat()
  const [input, setInput] = useState('')
  const textareaRef = useRef(null)

  // Auto-resize textarea
  useEffect(() => {
    if (textareaRef.current) {
      textareaRef.current.style.height = 'auto'
      const newHeight = Math.min(textareaRef.current.scrollHeight, 160)
      textareaRef.current.style.height = `${newHeight}px`
    }
  }, [input])

  const handleSubmit = (e) => {
    e.preventDefault()

    const message = input.trim()
    if (!message || isStreaming) return

    sendMessage(message)
    setInput('')

    // Reset textarea height
    if (textareaRef.current) {
      textareaRef.current.style.height = 'auto'
    }
  }

  const handleKeyDown = (e) => {
    if (e.key === 'Enter' && !e.shiftKey) {
      e.preventDefault()
      handleSubmit(e)
    }
  }

  return (
    <div className="bg-background/80 backdrop-blur-sm px-4 md:px-8 lg:px-12 py-4">
      <form onSubmit={handleSubmit} className="max-w-5xl mx-auto">
        <div className="relative">
          {/* Modern input container with shadow and border */}
          <div className="relative bg-card rounded-3xl shadow-lg border border-border/50 hover:border-border transition-all duration-200 focus-within:ring-2 focus-within:ring-ring focus-within:border-transparent">
            <textarea
              ref={textareaRef}
              value={input}
              onChange={(e) => setInput(e.target.value)}
              onKeyDown={handleKeyDown}
              placeholder="اكتب سؤالك القانوني هنا..."
              disabled={isStreaming}
              rows={1}
              className="w-full min-h-[56px] max-h-[160px] pl-24 pr-5 py-4 bg-transparent text-foreground rounded-3xl resize-none focus:outline-none disabled:opacity-50 disabled:cursor-not-allowed transition-all duration-150 text-[15px] leading-relaxed placeholder:text-muted-foreground/60"
              style={{ direction: 'rtl' }}
            />

            {/* Send button inside input */}
            <button
              type="submit"
              disabled={isStreaming || !input.trim()}
              className="absolute left-2 bottom-2 bg-primary text-primary-foreground px-6 py-2.5 rounded-2xl font-medium hover:bg-primary/90 active:scale-95 transition-all duration-150 disabled:opacity-50 disabled:cursor-not-allowed disabled:hover:bg-primary shadow-md hover:shadow-lg flex items-center gap-2"
            >
              {isStreaming ? (
                <>
                  <span className="w-4 h-4 border-2 border-primary-foreground/30 border-t-primary-foreground rounded-full animate-spin"></span>
                  <span>جارٍ...</span>
                </>
              ) : (
                <>
                  <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 19l9 2-9-18-9 18 9-2zm0 0v-8" />
                  </svg>
                  <span>إرسال</span>
                </>
              )}
            </button>
          </div>

          {/* Helper text */}
          <div className="mt-2 text-xs text-muted-foreground text-center">
            اضغط Enter للإرسال أو Shift+Enter لسطر جديد
          </div>
        </div>
      </form>
    </div>
  )
}
